import EFPicture from '@elem/compCommon/EFPicture';
import { FormatMoneyLocal } from 'eco-design-micro/price/FormatMoneyLocal';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

const defaultBundle = {
    id: 'delta_pro_ultra',
    name: 'EcoFlow DELTA Pro Ultra (1 inverter + 1 battery)',
    img: '/responsive/picture/common-products/delta_pro_ultra.png',
    details: 'this is a detail text secntence!',
    limit: 1,
    productId: '6859087282249',
    variantId: '40563653378121',
    // quantity: 1,
    children: [
        {
            name: 'EcoFlow DELTA Pro Ultra (1 inverter + 1 battery)',
            img: '/responsive/picture/common-products/smart_home_panel_2.png',
            details: ['this is a detail text secntence!', 'this is a detail text secntence! 222'],
            limit: 1,
            productId: '6859087151177',
            variantId: '40589642039369',
        },
    ],
};

export default function CustomizeBundle({ bundle = defaultBundle, callDetails, updateBundle, callInstallation }: any) {
    const { useState, useEffect, useRouter, useLang, gtm, Link } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('customize_bundle_for_dpu');

    const handleCalculate = (n: number, childVariantId?: string) => {
        if (!childVariantId) {
            const tempBundle = JSON.parse(JSON.stringify(bundle));
            if (tempBundle?.id === 'dpu') {
                const battery = tempBundle?.children?.find((child: any) => child?.id === 'dpu_battery');
                if (battery) {
                    battery.limit = n * 4;
                    if (battery.quantity > battery.limit) {
                        battery.quantity = battery.limit;
                    }
                }
            }
            const newBundle = { ...tempBundle, quantity: n };
            updateBundle(newBundle);
        } else {
            const tempChildren = JSON.parse(JSON.stringify(bundle?.children));
            const targetChildIdx = tempChildren?.findIndex((item: any) => item?.variantId === childVariantId);
            const target = tempChildren[targetChildIdx];
            if (targetChildIdx !== -1) {
                const newBundle = {
                    ...bundle,
                    children: [...tempChildren.slice(0, targetChildIdx), { ...target, quantity: n }, ...tempChildren.slice(targetChildIdx + 1)],
                };
                updateBundle(newBundle);
            }
        }
    };

    const AddReduceCalc = ({ data, callback }: any) => {
        const NUM_MIN = data?.min || 0;
        const NUM_MAX = data?.inventory > data?.limit && data?.limit > 0 ? data?.limit : data?.inventory > 0 ? data?.inventory : 0;
        const { useState } = useGlobal();
        const [number, setNumber] = useState(data?.quantity ?? 0);
        const [showMaxTip, setShowMaxTip] = useState(false);

        const reduceNumber = () => {
            if (number <= NUM_MIN) return false;
            setNumber(number - 1);
            callback(number - 1);
            try {
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'bundle_remove_from_cart',
                    product_name: data?.name,
                    price: data?.discountPrice,
                    quantity: number - 1,
                    button_name: '-',
                    list_name: 'none',
                    tag: 'none',
                });
            } catch (e) {
                console.error(e);
            }
        };

        const addNumber = () => {
            if (number >= NUM_MAX) {
                setShowMaxTip(true);
                setTimeout(() => {
                    setShowMaxTip(false);
                }, 2000);
                return false;
            }
            setNumber(number + 1);
            callback(number + 1);
            try {
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'bundle_add_to_cart',
                    product_name: data?.name,
                    price: data?.discountPrice,
                    quantity: number + 1,
                    button_name: '+',
                    list_name: 'none',
                    tag: 'none',
                });
            } catch (e) {
                console.error(e);
            }
        };

        const inputChange = (e: any) => {
            const v = e.target.value.replace(/[^0-9]/g, '');
            if (v < NUM_MIN || v > NUM_MAX) {
                return;
            }
            setNumber(Number(v));
            callback(Number(v));
        };

        return (
            <div className="bundle-calculator">
                <div className={number <= NUM_MIN ? 'addSubtractor-reduce disable' : 'addSubtractor-reduce'} onClick={reduceNumber}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <g className="svg-g">
                            <rect width="24" height="24" rx="12" fill="#38383D" />
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M8.24129 12.545H15.7516C15.9291 12.545 16.0749 12.4939 16.1889 12.3916C16.303 12.2893 16.3601 12.1586 16.3601 11.9996C16.3601 11.8405 16.303 11.7098 16.1889 11.6075C16.0749 11.5052 15.9291 11.4541 15.7516 11.4541H8.24129C8.06381 11.4541 7.91804 11.5052 7.80395 11.6075C7.68986 11.7098 7.63281 11.8405 7.63281 11.9996C7.63281 12.1586 7.68986 12.2893 7.80395 12.3916C7.91804 12.4939 8.06381 12.545 8.24129 12.545Z"
                                fill="#E6E6E6"
                            />
                        </g>
                    </svg>
                </div>
                {/* <div className="addSubtractor-number">{number}</div> */}
                <input className="addSubtractor-number" value={number} onChange={inputChange} />
                <div className={number >= NUM_MAX ? 'addSubtractor-add disable' : 'addSubtractor-add'} onClick={addNumber}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24" fill="none">
                        <g className="svg-g">
                            <rect width="100%" height="100%" rx="12" fill="#38383D" />
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M8.24129 12.6088H11.388V15.7555C11.388 15.933 11.445 16.0788 11.5591 16.1929C11.6732 16.3069 11.819 16.364 11.9964 16.364C12.1739 16.364 12.3197 16.3069 12.4338 16.1929C12.5479 16.0788 12.6049 15.933 12.6049 15.7555V12.6088H15.7516C15.9291 12.6088 16.0749 12.5518 16.1889 12.4377C16.303 12.3236 16.3601 12.1778 16.3601 12.0004C16.3601 11.8229 16.303 11.6771 16.1889 11.563C16.0749 11.4489 15.9291 11.3919 15.7516 11.3919H12.6049V8.24519C12.6049 8.06772 12.5479 7.92194 12.4338 7.80785C12.3197 7.69376 12.1739 7.63672 11.9964 7.63672C11.819 7.63672 11.6732 7.69376 11.5591 7.80785C11.445 7.92194 11.388 8.06772 11.388 8.24519V11.3919H8.24129C8.06381 11.3919 7.91804 11.4489 7.80395 11.563C7.68986 11.6771 7.63281 11.8229 7.63281 12.0004C7.63281 12.1778 7.68986 12.3236 7.80395 12.4377C7.91804 12.5518 8.06381 12.6088 8.24129 12.6088Z"
                                fill="#E6E6E6"
                            />
                        </g>
                    </svg>
                </div>
                {showMaxTip && <p className="reach-max">{t('reach_max')}</p>}
            </div>
        );
    };

    return (
        <div className={`customize-bundle ${css['customize-bundle']} ${bundle?.quantity > 0 ? 'select' : ''}`}>
            <div className="bundle-img">
                <EFPicture src={bundle?.img} alt={bundle?.name} />
            </div>
            <div className="bundle-info">
                <div className="bundle-parent-product">
                    <p className="bundle-name">{bundle?.name}</p>
                    <div className={`bundle-price-box ${bundle?.details ? '' : 'no-details'}`}>
                        <span className="discount-price">{FormatMoneyLocal(bundle?.discountPrice, locale)}</span>
                        {bundle?.discountPrice !== bundle?.originalPrice && (
                            <span className="original-price">{FormatMoneyLocal(bundle?.originalPrice, locale)}</span>
                        )}
                        {bundle?.discountPrice !== bundle?.originalPrice && (
                            <span className="save-price">
                                {t('save')} {FormatMoneyLocal(Math.round(bundle?.originalPrice * 100 - bundle?.discountPrice * 100) / 100, locale)}
                            </span>
                        )}
                    </div>
                    {(bundle?.limit > 1 || bundle?.details) && (
                        <div className={`bundle-detail-calculator ${bundle?.details ? '' : 'no-details'}`}>
                            {bundle?.details && (
                                <div className="bundle-details" onClick={() => callDetails({ title: bundle?.name, text: bundle?.details })}>
                                    <span className="details-text">{t('details')}</span>
                                    <svg className="details-svg" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                        <path
                                            d="M4.69531 1.76953L8.69531 5.76953L4.69531 9.76953"
                                            stroke="#3F68E0"
                                            strokeWidth="1.05"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </div>
                            )}
                            {bundle?.limit > 1 && (
                                <AddReduceCalc
                                    data={{
                                        id: bundle?.id,
                                        name: bundle?.name,
                                        discountPrice: bundle?.discountPrice,
                                        inventory: bundle?.inventory,
                                        limit: bundle?.limit,
                                        quantity: bundle?.quantity,
                                        min: bundle?.min || 0,
                                    }}
                                    callback={handleCalculate}
                                />
                            )}
                        </div>
                    )}
                    {bundle?.limit === 1 && (
                        <span
                            className={`check-circle ${bundle?.quantity === 1 ? 'checked' : ''}`}
                            onClick={() => handleCalculate(bundle?.quantity === 1 && bundle?.min !== 1 ? 0 : 1)}
                        >
                            {bundle?.quantity === 1 && (
                                <svg className="checked-icon" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                                    <path d="M9 14.5L13 18.5L19 10" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            )}
                        </span>
                    )}
                </div>
                {bundle?.children?.length > 0 && (
                    <ul className="bundle-children-products">
                        {bundle?.children?.map((child: any, k: number) => (
                            <li
                                className="bundle-parent-product child"
                                key={`${child?.variantId}_${child?.quantity}_${child?.discountPrice}_${locale}_${child?.virtualPrice}_${k}`}
                            >
                                <div className="bundle-child-img">
                                    <EFPicture src={child?.img} alt={child?.name} />
                                </div>
                                <div className="bundle-info">
                                    <p className="bundle-name">{child?.name}</p>
                                    <div className="bundle-price-box">
                                        <span className="discount-price">
                                            {FormatMoneyLocal(
                                                child?.virtualCondition?.includes(child?.quantity) && child?.virtualSites?.includes(locale)
                                                    ? child?.virtualPrice
                                                    : child?.discountPrice,
                                                locale,
                                            )}
                                        </span>
                                        {child?.discountPrice !== child?.originalPrice && !child?.virtualPrice && (
                                            <span className="original-price">{FormatMoneyLocal(child?.originalPrice, locale)}</span>
                                        )}
                                        {child?.discountPrice !== child?.originalPrice && !child?.virtualPrice && (
                                            <span className="save-price">
                                                {t('save')}{' '}
                                                {FormatMoneyLocal(Math.round(child?.originalPrice * 100 - child?.discountPrice * 100) / 100, locale)}
                                            </span>
                                        )}
                                    </div>
                                    {(child?.limit > 1 || child?.details) && (
                                        <div className={`bundle-detail-calculator ${child?.details ? '' : 'no-details'}`}>
                                            {child?.details && (
                                                <div className="bundle-details" onClick={() => callDetails({ title: child?.name, text: child?.details })}>
                                                    <span className="details-text">{t('details')}</span>
                                                    <svg
                                                        className="details-svg"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="12"
                                                        height="12"
                                                        viewBox="0 0 12 12"
                                                        fill="none"
                                                    >
                                                        <path
                                                            d="M4.69531 1.76953L8.69531 5.76953L4.69531 9.76953"
                                                            stroke="#3F68E0"
                                                            strokeWidth="1.05"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                    </svg>
                                                </div>
                                            )}
                                            {child?.limit > 1 && (
                                                <AddReduceCalc
                                                    data={{
                                                        id: child?.id,
                                                        name: child?.name,
                                                        discountPrice: child?.discountPrice,
                                                        inventory: child?.inventory,
                                                        limit: child?.limit,
                                                        quantity: child?.quantity,
                                                    }}
                                                    callback={(n: number) => handleCalculate(n, child?.variantId)}
                                                />
                                            )}
                                        </div>
                                    )}
                                    {child?.limit === 1 && (
                                        <span
                                            className={`check-circle ${child?.quantity === 1 ? 'checked' : ''}`}
                                            onClick={() => handleCalculate(bundle?.quantity === 1 && bundle?.min !== 1 ? 0 : 1, child?.variantId)}
                                        >
                                            {child?.quantity === 1 && (
                                                <svg
                                                    className="checked-icon"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="28"
                                                    height="28"
                                                    viewBox="0 0 28 28"
                                                    fill="none"
                                                >
                                                    <path
                                                        d="M9 14.5L13 18.5L19 10"
                                                        stroke="white"
                                                        strokeWidth="1.5"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                </svg>
                                            )}
                                        </span>
                                    )}
                                </div>
                            </li>
                        ))}
                    </ul>
                )}
                {locale === 'us' && bundle?.id === 'shp2' && (
                    <div className="bundle-installation" onClick={() => callInstallation(true)}>
                        <span className="installation-text">{t('main_product.free_installation')}</span>
                        <svg className="installation-svg" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                            <path
                                d="M4.69531 1.76953L8.69531 5.76953L4.69531 9.76953"
                                stroke="#3F68E0"
                                strokeWidth="1.05"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </div>
                )}
            </div>
        </div>
    );
}
